import axios from "axios";

const BASE_API_URL = "/api/product";

class ProductService {
  //依 productID 取得已產生的真愛合盤報告
  getLoveReport(productID) {
    return axios.post(BASE_API_URL + "/love-match/find", { productID });
  }

  //依 orderID 查這張訂單的真愛合盤報告產生了沒（付款後輪詢用）
  //  回傳 data: { ready: true, report: {...} } 或 { ready: false }
  getLoveReportByOrder(orderID) {
    return axios.post(BASE_API_URL + "/love-match/by-order", { orderID });
  }

  //依 productID 取得已產生的流年之書報告
  getFlowYearReport(productID) {
    return axios.post(BASE_API_URL + "/flow-year/find", { productID });
  }

  //依 orderID 查這張訂單的流年之書報告產生了沒（付款後輪詢用）
  //  回傳 data: { ready: true, report: {...} } 或 { ready: false }
  getFlowYearReportByOrder(orderID) {
    return axios.post(BASE_API_URL + "/flow-year/by-order", { orderID });
  }

  //依 productID 取得已產生的親子合盤報告
  getFamilyMatchReport(productID) {
    return axios.post(BASE_API_URL + "/family-match/find", { productID });
  }

  //依 orderID 查這張訂單的親子合盤報告產生了沒（付款後輪詢用）
  //  回傳 data: { ready: true, report: {...} } 或 { ready: false }
  getFamilyMatchReportByOrder(orderID) {
    return axios.post(BASE_API_URL + "/family-match/by-order", { orderID });
  }

  //依 productID 取得奇門遁甲報告（書房點卡片用）
  getQimenReport(productID) {
    return axios.post(BASE_API_URL + "/qimen-dunjia/find", { productID });
  }

  //依 orderID 查奇門遁甲報告產生了沒（付款後輪詢用）
  getQimenReportByOrder(orderID) {
    return axios.post(BASE_API_URL + "/qimen-dunjia/by-order", { orderID });
  }
}

export default new ProductService();
